// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3SV4T","rightAdornment":"Header_rightAdornment__VcStV"};